<template>
	<section class="newsletter">
		<div class="row align-center">
			<div class="columns column12">
				<h2>{{ header }}</h2>
				<div v-parse-links v-html="content" />
				<!-- Begin Mailchimp Signup Form -->
				<div id="mc_embed_signup" class="mc-column">
					<form
						id="mc-embedded-subscribe-form"
						:action="link"
						method="post"
						name="mc-embedded-subscribe-form"
						class="validate newsletter"
						target="_blank"
						novalidate
					>
						<input
							id="mce-EMAIL"
							type="email"
							value=""
							name="EMAIL"
							class="required email"
							:placeholder="$t('formEmail')"
						/>
						<input
							id="mc-embedded-subscribe"
							type="submit"
							name="subscribe"
							class="button"
							:value="button"
						/>
						<div id="mce-responses" class="clear">
							<div id="mce-error-response" class="response" style="display: none" />
							<div id="mce-success-response" class="response" style="display: none" />
						</div>
						<!-- real people should not fill this in - do not remove this or risk bot signups-->
						<div style="position: absolute; left: -5000px" aria-hidden="true">
							<input type="text" :name="formid" tabindex="-1" value="" />
						</div>
					</form>
				</div>
				<!-- end Mailchimp Signup Form -->
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	header: { type: String, default: '' },
	content: { type: String, default: '' },
	button: { type: String, default: '' },
	formid: { type: String, default: '' },
	link: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.newsletter {
	background: var(--contentblock-background-color);

	p {
		max-width: 600px;
		margin: 0 auto 20px;
	}

	input {
		appearance: none;
	}

	input:not(.button) {
		color: var(--body-color);
		border: none;
		width: 280px;
		padding: 0 10px;
		line-height: 50px;
		outline: none !important;
	}

	.button {
		border: none;
		margin: 0;
		cursor: pointer;
		outline: none;
	}
}

.package-subpage section.newsletter {
	padding: 50px 0;
}

section.newsletter,
.newsletter h2 {
	color: #fff;
}

section.newsletter {
	padding: 50px 0 0;
}

form.newsletter {
	background: #fff;
	padding: 10px;
	margin: 20px auto 50px;
	box-shadow: 0 24px 24px rgb(0 0 0 / 15%);
	display: flex;
	flex-flow: row wrap;
	justify-content: space-between;
}

.mc-column {
	margin: 0 auto;
	display: flex;
	float: none;
}

@media (max-width: 680px) {
	.newsletter input {
		width: 100% !important;
		text-align: center;

		&.button {
			width: 100%;
		}
	}
}
</style>
